import { html } from "lit";
import { getDummyText, renderStandardPictureElement } from "../../../../utils";

export const sucessStoryTeaserData = {
    title: "Success story title",
    body: getDummyText(260),
    subline: "Lorem ipsum dolor sit amet",
    linkText: "Geschichten lesen",
    linkUrl: "#",
};

export const TeaserSuccessStoryTemplate = (args) => html`
    <div class="ux-iws-teaser-success-story">
        <div class="ux-iws-teaser-success-story__img-container">
            ${renderStandardPictureElement({
                width: 400,
                height: 400,
            })}
        </div>
        <div class="ux-iws-teaser-success-story__content">
            <ux-icon
                class="ux-iws-teaser-success-story__icon"
                name="quotation-mark"
            >
            </ux-icon>
            <h2 class="ux-text-headline ux-text-headline--medium">
                ${args.title}
            </h2>
            ${args.variant === "with subline"
                ? html`<span class="ux-u-text-bold ux-u-margin-bottom-5"
                      >${args.subline}</span
                  >`
                : ``}
            <p class="ux-text-normal ux-text-normal--light-gray">
                ${args.body}
            </p>
            <a href="${args.linkUrl}" class="ux-button ux-button--green">
                ${args.linkText}
            </a>
        </div>
    </div>
`;
